<div class="ai-review" *ngIf="result">
  <!-- Resumo -->
  <div class="ai-review__summary">
    <div class="ai-review__stat">
      <span class="ai-review__stat-value">{{ acceptedTotal }}<small>/{{ reviewTotal }}</small></span>
      <span class="ai-review__stat-label">{{ 'ai-extraction.review.accepted' | translate }}</span>
    </div>
    <div class="ai-review__stat" *ngIf="overallPct !== null">
      <span class="ai-review__stat-value">{{ overallPct }}%</span>
      <span class="ai-review__stat-label">{{ 'ai-extraction.review.confidence' | translate }}</span>
    </div>
    <div class="ai-review__stat">
      <span class="ai-review__stat-value">{{ chargedCredits }}</span>
      <span class="ai-review__stat-label">{{ 'ai-extraction.review.credits-used' | translate }}</span>
    </div>
    <div class="ai-review__summary-actions">
      <button type="button" class="btn btn-sm btn-soft-success" (click)="setAll(true)">
        <i class="ri-check-double-line me-1"></i>{{ 'ai-extraction.review.accept-all' | translate }}
      </button>
      <button type="button" class="btn btn-sm btn-soft-secondary" (click)="setAll(false)">
        {{ 'ai-extraction.review.reject-all' | translate }}
      </button>
    </div>
  </div>

  <div class="alert alert-warning ai-review__alert" *ngIf="missingCritical.length" role="status">
    <i class="ri-error-warning-line me-1"></i>
    <strong>{{ 'ai-extraction.review.missing-critical' | translate }}</strong>
    <span class="badge badge-soft-warning ms-1" *ngFor="let key of missingCritical">{{ key | translate }}</span>
  </div>

  <div class="alert alert-info ai-review__alert" *ngIf="crossIssues.length" role="status">
    <i class="ri-information-line me-1"></i>
    <span *ngFor="let issue of crossIssues; let last = last">
      {{ 'ai-extraction.issues.' + issue.code | translate }}<span *ngIf="!last"> · </span>
    </span>
  </div>

  <div class="ai-review__body">
    <!-- Documento -->
    <div class="ai-review__viewer">
      <app-ai-doc-viewer [source]="viewerSource" [page]="viewerPage" [snippet]="viewerSnippet"
        [loading]="viewerLoading"></app-ai-doc-viewer>
    </div>

    <!-- Valores -->
    <div class="ai-review__panel">
      <ul class="nav nav-tabs nav-tabs-custom ai-review__tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button type="button" class="nav-link" role="tab" [class.active]="activeTab === 'fields'"
            [attr.aria-selected]="activeTab === 'fields'" (click)="selectTab('fields')">
            {{ 'ai-extraction.tabs.fields' | translate }}
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button type="button" class="nav-link" role="tab" [class.active]="activeTab === 'items'"
            [attr.aria-selected]="activeTab === 'items'" (click)="selectTab('items')">
            {{ 'ai-extraction.tabs.items' | translate }}
            <span class="badge badge-soft-primary ms-1">{{ divisions.length + characteristics.length + proximities.length }}</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button type="button" class="nav-link" role="tab" [class.active]="activeTab === 'owners'"
            [attr.aria-selected]="activeTab === 'owners'" (click)="selectTab('owners')">
            {{ 'ai-extraction.tabs.owners' | translate }}
            <span class="badge badge-soft-primary ms-1">{{ owners.length }}</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button type="button" class="nav-link" role="tab" [class.active]="activeTab === 'documents'"
            [attr.aria-selected]="activeTab === 'documents'" (click)="selectTab('documents')">
            {{ 'ai-extraction.tabs.documents' | translate }}
            <span class="badge badge-soft-primary ms-1">{{ documents.length }}</span>
          </button>
        </li>
      </ul>

      <div class="ai-review__scroll">
        <!-- ─────────────────────────── Campos ─────────────────────────── -->
        <ng-container *ngIf="activeTab === 'fields'">
          <div class="ai-review__empty" *ngIf="!sections.length">
            {{ 'ai-extraction.review.no-fields' | translate }}
          </div>

          <section class="ai-section" *ngFor="let section of sections; trackBy: trackSection">
            <header class="ai-section__header">
              <button type="button" class="ai-section__toggle" (click)="toggleSection(section)"
                [attr.aria-expanded]="!section.collapsed">
                <i [class]="section.icon"></i>
                <span>{{ section.titleKey | translate }}</span>
                <span class="badge badge-soft-success">{{ section.accepted }}/{{ section.rows.length }}</span>
                <i class="ri-arrow-down-s-line ai-section__chevron" [class.is-collapsed]="section.collapsed"></i>
              </button>
              <div class="ai-section__actions">
                <button type="button" class="btn btn-sm btn-link" (click)="setSection(section, true)">
                  {{ 'ai-extraction.review.accept-section' | translate }}
                </button>
                <button type="button" class="btn btn-sm btn-link text-muted" (click)="setSection(section, false)">
                  {{ 'ai-extraction.review.reject-section' | translate }}
                </button>
              </div>
            </header>

            <div class="ai-section__rows" *ngIf="!section.collapsed">
              <div class="ai-field" *ngFor="let row of section.rows; trackBy: trackRow"
                [class.is-accepted]="row.accepted" [class.is-selected]="selectedKey === '' + row.item.id">
                <div class="ai-field__main">
                  <div class="form-check ai-field__check">
                    <input class="form-check-input" type="checkbox" [id]="'ai-field-' + row.item.id"
                      [checked]="row.accepted" (change)="toggleField(row)" />
                    <label class="form-check-label" [for]="'ai-field-' + row.item.id">
                      {{ row.labelKey | translate }}
                      <span class="ai-field__unit" *ngIf="row.unit">({{ row.unit }})</span>
                    </label>
                  </div>

                  <div class="ai-field__editor" [ngSwitch]="row.editor">
                    <ng-select *ngSwitchCase="'catalog'" [items]="row.options" bindLabel="label" bindValue="id"
                      [clearable]="true" [(ngModel)]="row.value" (ngModelChange)="onFieldEdited(row)"
                      [placeholder]="'ai-extraction.review.choose' | translate"></ng-select>

                    <input *ngSwitchCase="'number'" type="number" class="form-control form-control-sm"
                      [(ngModel)]="row.value" (ngModelChange)="onFieldEdited(row)" />

                    <input *ngSwitchCase="'date'" type="text" class="form-control form-control-sm flatpickr-input"
                      mwlFlatpickr [allowInput]="true" appDateDigitsMask [convertModelValue]="true" [dateFormat]="'d/m/Y'" [(ngModel)]="row.value"
                      (ngModelChange)="onFieldEdited(row)" />

                    <div *ngSwitchCase="'boolean'" class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" [(ngModel)]="row.value"
                        (ngModelChange)="onFieldEdited(row)" />
                    </div>

                    <input *ngSwitchCase="'text'" type="text" class="form-control form-control-sm"
                      [(ngModel)]="row.value" (ngModelChange)="onFieldEdited(row)" />

                    <span *ngSwitchDefault class="ai-field__readonly">{{ row.readLabel }}</span>
                  </div>
                </div>

                <div class="ai-field__meta">
                  <span class="badge" *ngIf="row.confidencePct !== null" [ngClass]="{
                      'badge-soft-success': row.confidenceLevel === 'high',
                      'badge-soft-warning': row.confidenceLevel === 'mid',
                      'badge-soft-danger': row.confidenceLevel === 'low'
                    }">
                    {{ 'ai-extraction.confidence.' + row.confidenceLevel | translate }} · {{ row.confidencePct }}%
                  </span>
                  <span class="badge badge-soft-info" *ngIf="row.item.handwritten">
                    <i class="ri-quill-pen-line me-1"></i>{{ 'ai-extraction.review.handwritten' | translate }}
                  </span>
                  <span class="badge badge-soft-primary" *ngIf="row.edited">
                    {{ 'ai-extraction.review.edited' | translate }}
                  </span>

                  <button type="button" class="ai-field__source" *ngIf="row.documentName"
                    (click)="showFieldEvidence(row)">
                    <i class="ri-eye-line me-1"></i>{{ row.documentName }}
                    <span *ngIf="row.item.page"> · {{ 'ai-extraction.review.page' | translate }} {{ row.item.page }}</span>
                  </button>

                  <button type="button" class="btn btn-sm btn-link ai-field__link" *ngIf="row.edited"
                    (click)="restoreField(row)">
                    <i class="ri-arrow-go-back-line me-1"></i>{{ 'ai-extraction.review.restore' | translate }}
                    <span class="text-muted">({{ row.readLabel }})</span>
                  </button>

                  <button type="button" class="btn btn-sm btn-link ai-field__link" *ngIf="row.alternatives.length"
                    (click)="toggleAlternatives(row)" [attr.aria-expanded]="row.showAlternatives">
                    {{ row.alternatives.length }} {{ 'ai-extraction.review.alternatives' | translate }}
                  </button>
                </div>

                <div class="ai-field__note ai-field__note--warn" *ngIf="row.overwrites">
                  <i class="ri-alert-line me-1"></i>
                  {{ 'ai-extraction.review.overwrites' | translate }}
                  <strong>{{ (row.currentLabel || '') | translate }}</strong>
                </div>

                <div class="ai-field__note" *ngFor="let issue of row.issues">
                  <i class="ri-information-line me-1"></i>{{ issue | translate }}
                </div>

                <div class="ai-field__alternatives" *ngIf="row.showAlternatives && row.alternatives.length">
                  <button type="button" class="ai-alternative" *ngFor="let alternative of row.alternatives"
                    (click)="useAlternative(row, alternative)">
                    <span class="ai-alternative__value">{{ alternative.label | translate }}</span>
                    <span class="ai-alternative__source">
                      {{ alternative.documentName }}
                      <span *ngIf="alternative.page"> · {{ 'ai-extraction.review.page' | translate }} {{ alternative.page }}</span>
                    </span>
                    <span class="badge" [ngClass]="alternative.conflicting ? 'badge-soft-warning' : 'badge-soft-success'">
                      {{ (alternative.conflicting ? 'ai-extraction.review.differs' : 'ai-extraction.review.confirms') | translate }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </section>

          <!-- Dados adicionais: informação lida que não tem campo no formulário -->
          <section class="ai-section" *ngIf="extras.length">
            <header class="ai-section__header">
              <div class="ai-section__toggle ai-section__toggle--static">
                <i class="ri-file-list-3-line"></i>
                <span>{{ 'ai-extraction.sections.extras' | translate }}</span>
              </div>
            </header>
            <p class="ai-section__hint">{{ 'ai-extraction.review.extras-hint' | translate }}</p>
            <div class="ai-section__rows">
              <div class="ai-extra" *ngFor="let row of extras; trackBy: trackRow">
                <span class="ai-extra__label">{{ row.labelKey | translate }}</span>
                <span class="ai-extra__value">{{ row.readLabel }} <small *ngIf="row.unit">{{ row.unit }}</small></span>
                <button type="button" class="ai-field__source" *ngIf="row.documentName" (click)="showFieldEvidence(row)">
                  <i class="ri-eye-line me-1"></i>{{ row.documentName }}
                </button>
              </div>
            </div>
          </section>

          <section class="ai-section" *ngIf="encumbrances.length">
            <header class="ai-section__header">
              <div class="ai-section__toggle ai-section__toggle--static">
                <i class="ri-scales-3-line"></i>
                <span>{{ 'ai-extraction.sections.encumbrances' | translate }}</span>
              </div>
            </header>
            <div class="ai-section__rows">
              <div class="ai-extra" *ngFor="let row of encumbrances; trackBy: trackRow">
                <span class="ai-extra__label">{{ row.data.type }}</span>
                <span class="ai-extra__value">
                  {{ row.data.description }}
                  <span *ngIf="row.data.holder"> · {{ row.data.holder }}</span>
                  <span *ngIf="row.data.amount"> · {{ row.data.amount | number: '1.0-2' }} €</span>
                </span>
                <button type="button" class="ai-field__source" *ngIf="row.documentName" (click)="showFieldEvidence(row)">
                  <i class="ri-eye-line me-1"></i>{{ row.documentName }}
                </button>
              </div>
            </div>
          </section>
        </ng-container>

        <!-- ─────────────── Divisões, características, zona ─────────────── -->
        <ng-container *ngIf="activeTab === 'items'">
          <div class="ai-review__empty"
            *ngIf="!divisions.length && !characteristics.length && !proximities.length">
            {{ 'ai-extraction.review.no-items' | translate }}
          </div>

          <section class="ai-section" *ngIf="divisions.length">
            <header class="ai-section__header">
              <div class="ai-section__toggle ai-section__toggle--static">
                <i class="ri-layout-masonry-line"></i>
                <span>{{ 'ai-extraction.sections.divisions' | translate }}</span>
              </div>
            </header>
            <div class="ai-section__rows">
              <div class="ai-field" *ngFor="let row of divisions; trackBy: trackRow" [class.is-accepted]="row.accepted">
                <div class="ai-item">
                  <input class="form-check-input" type="checkbox" [checked]="row.accepted" [disabled]="row.blocked"
                    (change)="toggleItem(row)" [attr.aria-label]="row.data.label" />
                  <ng-select class="ai-item__select" [items]="lookups?.divisions || []" bindLabel="label" bindValue="id"
                    [clearable]="false" [(ngModel)]="row.data.divisionId" (ngModelChange)="onDivisionChosen(row)"
                    [placeholder]="row.data.label"></ng-select>
                  <input type="number" min="0" class="form-control form-control-sm ai-item__count"
                    [(ngModel)]="row.data.count" (ngModelChange)="onItemEdited(row)"
                    [attr.aria-label]="'ai-extraction.review.count' | translate" />
                </div>
                <div class="ai-field__meta">
                  <span class="badge" *ngIf="row.confidencePct !== null" [ngClass]="{
                      'badge-soft-success': row.confidenceLevel === 'high',
                      'badge-soft-warning': row.confidenceLevel === 'mid',
                      'badge-soft-danger': row.confidenceLevel === 'low'
                    }">{{ row.confidencePct }}%</span>
                  <span class="text-muted" *ngIf="row.areasText">{{ row.areasText }} m²</span>
                  <span class="badge badge-soft-info" *ngIf="row.data.floors?.length">
                    {{ 'ai-extraction.review.floors-added' | translate }}: {{ row.data.floors.length }}
                  </span>
                  <span class="badge badge-soft-warning" *ngIf="row.data.hasConflict">
                    {{ 'ai-extraction.review.differs' | translate }}
                  </span>
                  <button type="button" class="ai-field__source" *ngIf="row.documentName" (click)="showFieldEvidence(row)">
                    <i class="ri-eye-line me-1"></i>{{ row.documentName }}
                  </button>
                </div>
                <div class="ai-field__note ai-field__note--warn" *ngIf="row.blockedKey">
                  <i class="ri-alert-line me-1"></i>{{ row.blockedKey | translate }}
                </div>
              </div>
            </div>
          </section>

          <section class="ai-section" *ngIf="characteristics.length">
            <header class="ai-section__header">
              <div class="ai-section__toggle ai-section__toggle--static">
                <i class="ri-star-line"></i>
                <span>{{ 'ai-extraction.sections.characteristics' | translate }}</span>
              </div>
            </header>
            <div class="ai-section__rows">
              <div class="ai-field" *ngFor="let row of characteristics; trackBy: trackRow"
                [class.is-accepted]="row.accepted">
                <div class="ai-item">
                  <input class="form-check-input" type="checkbox" [checked]="row.accepted" [disabled]="row.blocked"
                    (change)="toggleItem(row)" [attr.aria-label]="row.data.label" />
                  <ng-select class="ai-item__select" [items]="lookups?.characteristics || []" bindLabel="label"
                    bindValue="id" groupBy="group" [clearable]="false" [(ngModel)]="row.data.characteristicId"
                    (ngModelChange)="onCharacteristicChosen(row)" [placeholder]="row.data.label"></ng-select>
                </div>
                <div class="ai-field__meta">
                  <span class="text-muted">{{ 'ai-extraction.review.read-as' | translate }} “{{ row.data.label }}”</span>
                  <span class="badge" *ngIf="row.confidencePct !== null" [ngClass]="{
                      'badge-soft-success': row.confidenceLevel === 'high',
                      'badge-soft-warning': row.confidenceLevel === 'mid',
                      'badge-soft-danger': row.confidenceLevel === 'low'
                    }">{{ row.confidencePct }}%</span>
                  <button type="button" class="ai-field__source" *ngIf="row.documentName" (click)="showFieldEvidence(row)">
                    <i class="ri-eye-line me-1"></i>{{ row.documentName }}
                  </button>
                </div>
                <div class="ai-field__note ai-field__note--warn" *ngIf="row.blockedKey">
                  <i class="ri-alert-line me-1"></i>{{ row.blockedKey | translate }}
                </div>
              </div>
            </div>
          </section>

          <section class="ai-section" *ngIf="proximities.length">
            <header class="ai-section__header">
              <div class="ai-section__toggle ai-section__toggle--static">
                <i class="ri-road-map-line"></i>
                <span>{{ 'ai-extraction.sections.proximities' | translate }}</span>
              </div>
            </header>
            <div class="ai-section__rows">
              <div class="ai-field" *ngFor="let row of proximities; trackBy: trackRow" [class.is-accepted]="row.accepted">
                <div class="ai-item">
                  <input class="form-check-input" type="checkbox" [checked]="row.accepted" [disabled]="row.blocked"
                    (change)="toggleItem(row)" [attr.aria-label]="row.data.label" />
                  <ng-select class="ai-item__select" [items]="lookups?.nearby || []" bindLabel="label" bindValue="id"
                    [clearable]="false" [(ngModel)]="row.data.nearbyId" (ngModelChange)="onNearbyChosen(row)"
                    [placeholder]="row.data.label"></ng-select>
                  <input type="number" min="0" class="form-control form-control-sm ai-item__count"
                    [(ngModel)]="row.data.distance" (ngModelChange)="onItemEdited(row)"
                    [attr.aria-label]="'ai-extraction.review.distance' | translate" />
                  <ng-select class="ai-item__unit" [items]="lookups?.units || []" bindLabel="label" bindValue="id"
                    [clearable]="false" [(ngModel)]="row.data.unitId" (ngModelChange)="onItemEdited(row)"></ng-select>
                </div>
                <div class="ai-field__meta">
                  <button type="button" class="ai-field__source" *ngIf="row.documentName" (click)="showFieldEvidence(row)">
                    <i class="ri-eye-line me-1"></i>{{ row.documentName }}
                  </button>
                </div>
                <div class="ai-field__note ai-field__note--warn" *ngIf="row.blockedKey">
                  <i class="ri-alert-line me-1"></i>{{ row.blockedKey | translate }}
                </div>
              </div>
            </div>
          </section>
        </ng-container>

        <!-- ───────────────────────── Proprietários ───────────────────────── -->
        <ng-container *ngIf="activeTab === 'owners'">
          <div class="ai-review__empty" *ngIf="!owners.length">
            {{ 'ai-extraction.review.no-owners' | translate }}
          </div>
          <p class="ai-section__hint" *ngIf="owners.length">
            {{ 'ai-extraction.owners.hint' | translate }}
          </p>

          <div class="ai-owner" *ngFor="let row of owners; trackBy: trackRow" [class.is-accepted]="row.accepted">
            <div class="ai-owner__head">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [id]="'ai-owner-' + row.item.id"
                  [checked]="row.accepted" [disabled]="row.blocked" (change)="toggleItem(row)" />
                <label class="form-check-label" [for]="'ai-owner-' + row.item.id">
                  {{ 'ai-extraction.owners.include' | translate }}
                </label>
              </div>
              <span class="badge badge-soft-secondary">{{ 'ai-extraction.owners.roles.' + (row.data.role || 'OWNER') | translate }}</span>
              <span class="badge badge-soft-info" *ngIf="row.data.sharePercentage">{{ row.data.sharePercentage }}%</span>
              <span class="badge badge-soft-danger" *ngIf="row.data.nifValid === false">
                {{ 'ai-extraction.owners.invalid-nif' | translate }}
              </span>
              <button type="button" class="ai-field__source ms-auto" *ngIf="row.documentName"
                (click)="showFieldEvidence(row)">
                <i class="ri-eye-line me-1"></i>{{ row.documentName }}
              </button>
            </div>

            <div class="row g-2">
              <div class="col-md-7">
                <label class="form-label" [for]="'ai-owner-name-' + row.item.id">{{ 'ai-extraction.owners.name' | translate }}</label>
                <input type="text" class="form-control form-control-sm" [id]="'ai-owner-name-' + row.item.id"
                  [(ngModel)]="row.data.fullName" (ngModelChange)="onItemEdited(row)" />
              </div>
              <div class="col-md-5">
                <label class="form-label" [for]="'ai-owner-nif-' + row.item.id">{{ 'ai-extraction.owners.nif' | translate }}</label>
                <input type="text" class="form-control form-control-sm" [id]="'ai-owner-nif-' + row.item.id"
                  [(ngModel)]="row.data.fiscalIdentification" (ngModelChange)="onItemEdited(row)" />
              </div>
              <div class="col-md-7">
                <label class="form-label" [for]="'ai-owner-email-' + row.item.id">{{ 'ai-extraction.owners.email' | translate }}</label>
                <input type="email" class="form-control form-control-sm" [id]="'ai-owner-email-' + row.item.id"
                  [(ngModel)]="row.data.email" (ngModelChange)="onItemEdited(row)" />
              </div>
              <div class="col-md-5">
                <label class="form-label" [for]="'ai-owner-phone-' + row.item.id">{{ 'ai-extraction.owners.phone' | translate }}</label>
                <input type="tel" class="form-control form-control-sm" [id]="'ai-owner-phone-' + row.item.id"
                  [(ngModel)]="row.data.phone" (ngModelChange)="onItemEdited(row)" />
              </div>
            </div>

            <div class="ai-owner__contacts" *ngIf="row.data.contactCandidates?.length">
              <span class="ai-owner__contacts-title">{{ 'ai-extraction.owners.existing' | translate }}</span>
              <div class="form-check" *ngFor="let contact of row.data.contactCandidates">
                <input class="form-check-input" type="radio" [name]="'ai-owner-contact-' + row.item.id"
                  [id]="'ai-owner-contact-' + row.item.id + '-' + contact.id"
                  [checked]="row.data.selectedContactId === contact.id" (change)="chooseContact(row, contact.id)" />
                <label class="form-check-label" [for]="'ai-owner-contact-' + row.item.id + '-' + contact.id">
                  {{ contact.name }}
                  <span class="text-muted" *ngIf="contact.email"> · {{ contact.email }}</span>
                  <span class="text-muted" *ngIf="contact.phone"> · {{ contact.phone }}</span>
                  <span class="badge badge-soft-success ms-1">
                    {{ 'ai-extraction.owners.matched-by.' + contact.matchedBy | translate }}
                  </span>
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" [name]="'ai-owner-contact-' + row.item.id"
                  [id]="'ai-owner-contact-' + row.item.id + '-new'" [checked]="!row.data.selectedContactId"
                  (change)="chooseContact(row, null)" />
                <label class="form-check-label" [for]="'ai-owner-contact-' + row.item.id + '-new'">
                  {{ 'ai-extraction.owners.create-new' | translate }}
                </label>
              </div>
            </div>

            <div class="ai-field__note ai-field__note--warn" *ngIf="row.blockedKey">
              <i class="ri-alert-line me-1"></i>{{ row.blockedKey | translate }}
            </div>
          </div>
        </ng-container>

        <!-- ─────────────────────────── Documentos ─────────────────────────── -->
        <ng-container *ngIf="activeTab === 'documents'">
          <div class="ai-document" *ngFor="let document of documents; trackBy: trackDocument">
            <div class="ai-document__head">
              <button type="button" class="ai-document__name" (click)="showDocument(document)">
                <i class="ri-file-text-line me-1"></i>{{ document.fileName }}
              </button>
              <span class="badge badge-soft-primary">{{ document.typeKey | translate }}</span>
              <span class="badge badge-soft-info" *ngIf="document.isHandwritten">
                {{ 'ai-extraction.review.handwritten' | translate }}
              </span>
              <span class="badge" [ngClass]="{
                  'badge-soft-success': document.status === 'DONE',
                  'badge-soft-danger': document.failed || document.status === 'UNREADABLE',
                  'badge-soft-warning': document.processing
                }">{{ 'ai-extraction.doc-status.' + document.status | translate }}</span>
              <span class="ai-document__credits">
                {{ document.billedCredits }} {{ 'ai-extraction.credits' | translate }}
              </span>
            </div>

            <p class="ai-document__summary" *ngIf="document.summary">{{ document.summary }}</p>
            <p class="ai-document__summary text-danger" *ngIf="document.error && (document.failed || !document.readable)">
              {{ document.error }}
            </p>

            <div class="ai-document__controls">
              <button type="button" class="btn btn-sm btn-soft-primary" *ngIf="document.failed && document.readable"
                (click)="requestRetry(document)">
                <i class="ri-refresh-line me-1"></i>{{ 'ai-extraction.review.retry' | translate }}
                <small class="ms-1">({{ 'ai-extraction.review.retry-free' | translate }})</small>
              </button>

              <ng-container *ngIf="document.canAttach">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" [id]="'ai-doc-attach-' + document.id"
                    [(ngModel)]="document.attachToProperty" (ngModelChange)="onDocumentChanged(document)" />
                  <label class="form-check-label" [for]="'ai-doc-attach-' + document.id">
                    {{ 'ai-extraction.documents.attach' | translate }}
                  </label>
                </div>
                <ng-select class="ai-document__type" *ngIf="documentTypes.length && document.attachToProperty"
                  [items]="documentTypes" bindLabel="name" bindValue="id" [clearable]="true"
                  [(ngModel)]="document.propertyDocumentTypeId" (ngModelChange)="onDocumentChanged(document)"
                  [placeholder]="'ai-extraction.documents.type' | translate"></ng-select>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <footer class="ai-review__footer">
    <button type="button" class="btn btn-light" (click)="closed.emit()" [disabled]="saving">
      {{ 'ai-extraction.review.later' | translate }}
    </button>
    <span class="ai-review__footer-note">
      {{ 'ai-extraction.review.footer-note' | translate }}
    </span>
    <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="saving || acceptedTotal === 0">
      <span class="spinner-border spinner-border-sm me-1" *ngIf="saving" role="status"></span>
      <i class="ri-magic-line me-1" *ngIf="!saving"></i>
      {{ 'ai-extraction.review.apply' | translate }} ({{ acceptedTotal }})
    </button>
  </footer>
</div>
